var bindEvent				= require('../eventHandlers/bindEvent');

function mobileNav() {

	var menuClass = '.js-mobile-trigger',
		hoverTxt = $(menuClass).find('.text').attr('data-hover'),
		normalTxt = $(menuClass).find('.text').attr('data-normal');

	var closeMenu = function() {
		$('body').removeClass('mobile-nav-active');
		$(menuClass).find('.text').text(normalTxt);
	};

	$(menuClass).on('click', function() {
		$('body').toggleClass('mobile-nav-active');

		if ($('body').hasClass('mobile-nav-active')) {
			$(this).find('.text').text(hoverTxt);
		} else {
			$(this).find('.text').text(normalTxt);
		}
	});

	$('.js-shadow-background').on('click', function() {
		closeMenu();
	});

	bindEvent('swr', closeMenu, false);

	$('.js-show-mobile-subnav').on('click', function() {
		$(this).closest('li').toggleClass('active-mobile-subnav');
	});

}

module.exports = mobileNav;